import { createContext, useState, ReactNode } from 'react';

type AlertType = 'info' | 'success' | 'warning' | 'error';

// Define the shape of the alert object
interface Alert {
  message: ReactNode; // widened from string so we can render links / rich content
  type: AlertType;
}

interface AlertContextType {
  alert: Alert | null;
  notifyMessage: (message: ReactNode, type?: AlertType) => void;
  hideNotifyMsg: () => void;
}

export const AlertContext = createContext<AlertContextType | undefined>(undefined);

export function NotifyProvider({ children }: { children: ReactNode }) {
  const [alert, setAlert] = useState<Alert | null>(null);

  const notifyMessage = (message: ReactNode, type: AlertType = 'info') => {
    setAlert({ message, type });
  };

  const hideNotifyMsg = () => {
    setAlert(null);
  };

  return <AlertContext.Provider value={{ alert, notifyMessage, hideNotifyMsg }}>{children}</AlertContext.Provider>;
}
